import { useState, useEffect } from "react";
import { Users } from "lucide-react";

const FIRST_NAMES = [
  "Marcus", "Sarah", "Devon", "Aaliyah", "Jordan", "Brianna", "Chris", "Maya",
  "Darnell", "Keisha", "Andre", "Tiffany", "Malik", "Jasmine", "Brandon",
  "Nicole", "Terrence", "Diamond", "Anthony", "Amber", "David", "Monique",
  "James", "Simone", "Robert", "Vanessa", "Michael", "Crystal", "Eric", "Bianca",
  "Kevin", "Destiny", "Aaron", "Tameka", "Troy", "Latoya", "Derek", "Shanice",
];

const MESSAGES = [
  (name) => `${name} just joined the Community Hub!`,
  (name) => `${name} completed their Business Clarity Assessment`,
  (name) => `${name} started the Quick Start Roadmap`,
  (name) => `New member ${name} connected in the Community`,
  (name) => `${name} just signed up for My Biz Consulting`,
];

const RecentActivity = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const showNotif = () => {
      if (dismissed) return;
      const name = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
      const msgFn = MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
      setMessage(msgFn(name));
      setVisible(true);
      setTimeout(() => setVisible(false), 4500);
    };

    // First show after 15-25 seconds
    const initialDelay = 15000 + Math.random() * 10000;
    const timer1 = setTimeout(showNotif, initialDelay);

    // Then show every 30-60 seconds
    const interval = setInterval(() => {
      if (!dismissed) showNotif();
    }, 30000 + Math.random() * 30000);

    return () => { clearTimeout(timer1); clearInterval(interval); };
  }, [dismissed]);

  if (dismissed) return null;

  return (
    <div className={`fixed bottom-6 left-6 z-[9990] transition-all duration-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
      <div className="bg-white rounded-xl shadow-lg border border-neutral-200 px-4 py-3 flex items-center gap-3 max-w-xs">
        <div className="w-8 h-8 bg-[#39FF14]/20 rounded-full flex items-center justify-center flex-shrink-0">
          <Users className="w-4 h-4 text-[#2BC40E]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-neutral-800 font-medium leading-snug">{message}</p>
          <p className="text-[10px] text-neutral-400 mt-0.5">Just now</p>
        </div>
        <button onClick={() => setDismissed(true)} className="text-neutral-300 hover:text-neutral-500 text-xs flex-shrink-0 ml-1" aria-label="Dismiss">
          ✕
        </button>
      </div>
    </div>
  );
};

export default RecentActivity;
